import clsx from "clsx";
import React from "react";

import CheckboxInput, {
  type CheckboxInputProps,
} from "@/components/compounds/forms/CheckboxInput";
import { Fieldset, FieldsetProps } from "@/components/compounds/forms/Fieldset";
import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./CheckboxGroup.module.css";

const ref = "checkbox-group";

interface CheckboxGroupProps
  extends Omit<CommonProps, "iconColor" | "secondaetColor">,
    Pick<FieldsetProps, "legend" | "subLegend">,
    Partial<Pick<FieldsetProps, "legendBackground" | "noBorder" | "noLegend">> {
  data: Array<CheckboxInputProps>;
  gapless?: boolean;
  legend: React.ReactNode;
  name: string;
  noBorder?: boolean;
  noLegend?: boolean;
}

function useCheckboxGroup(props: CheckboxGroupProps) {
  const { gapless, name = createId(ref), noBorder, noLegend } = props;

  const className = clsx(
    styles[ref],
    gapless && styles.gapless,
    !noBorder && styles.border,
    !noLegend && styles.legend,
    props.className,
  );

  return {
    className,
    name,
  };
}

function CheckboxGroup(props: CheckboxGroupProps) {
  const { data, eventGroup } = props;
  const { className, name } = useCheckboxGroup(props);

  return data.length === 0 ? null : (
    <Fieldset {...props} className={className} inline noPadding thinBorder>
      {data.map((item, index) => {
        return (
          <CheckboxInput
            key={`${name}_${index}`}
            color={props.color}
            eventGroup={eventGroup}
            id={`${name}_${index}`}
            {...item}
            name={item.name}
          />
        );
      })}
    </Fieldset>
  );
}

export default CheckboxGroup;
export { CheckboxGroup, type CheckboxGroupProps };
